import styled from '@emotion/styled';
import { Button as ButtonBase } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React from 'react';
import { theme } from '../../configs/styled';

export interface IButtonProps extends ButtonProps {
  children?: React.ReactNode;
}

const Button: React.FC<IButtonProps> = ({ children, ...props }) => {
  return <ButtonBase {...props}>{children}</ButtonBase>;
};

export default styled(Button)`
  &.ant-btn-primary:hover,
  &.ant-btn-primary:focus {
    color: ${theme.palettes.white};
    background-color: ${theme.palettes.primary80};
    border-color: ${theme.palettes.primary80};
  }
  border-radius: 2px;
  &.ant-btn-primary {
    color: ${theme.palettes.white};
    background-color: ${theme.palettes.primary};
    border-color: ${theme.palettes.primary};
  }
`;
